module.exports = __webpack_public_path__ + "img/suit (1).92a458a9.png";